import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var FacebookIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M15.58,12.94l.39-3H13V7.72c-.16-.9,1.37-.78,1.37-.78H16V4.18a21.69,21.69,0,0,0-2.25-.12C11.52,4.06,10,5.5,10,8.13V9.94H7v3h3v7h3v-7Z"
}), 'FacebookIcon');